import { render, staticRenderFns } from "./NewCostForm.vue?vue&type=template&id=cb789e24&scoped=true&"
import script from "./NewCostForm.vue?vue&type=script&lang=js&"
export * from "./NewCostForm.vue?vue&type=script&lang=js&"
import style0 from "./NewCostForm.vue?vue&type=style&index=0&id=cb789e24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb789e24",
  null
  
)

export default component.exports